import FaOx from '@/ox/src/locale/fa'
import FaLocale from '@/locale/fa'
import API_JSON from '../public/swagger/openapi.json'
import lodash from 'lodash'
window.API = API_JSON
const fa = lodash.merge(FaOx, FaLocale)

// NOTE: put all applciation config here
export default {
  homeURL: '/login',
  locale: 'fa',
  localeDateFormat: 'LLLL',
  localeDateString: 'fa-IR',
  locales: {
    fa
  },
  rtl: true,
  apiBaseURL: process.env.VUE_APP_API_BASE_URL,
  //apiBaseURL: 'http://127.0.0.1:5000',
  cdnBaseURL: process.env.VUE_APP_CDN_BASE_URL,
  apiJson: API_JSON,
  brandLogo: 'https://cdn.aviddent.ir/avid-logo.svg',
  defaultPagesArtwork: '/img/samples/artwork.png',
  darkTheme: false,
  themes: {
    light: {
      headerColor: '#5d6486',
      mainContent: '#ffffff',
      sidebarContent: '#fafafa',
      formInputColor: '#F3F7F9',
      borderColor: '#E1E7EE',
      buttonSuccess: '#0fc86e'
    },
    dark: {
      headerColor: '#5d6486',
      mainContent: '#5d6486',
      sidebarContent: '2C2C2C',
      formInputColor: '#2C2C2C',
      borderColor: '#4E4E4E'
    }
  },
  layout: {
    mainPanelLayout: 'panel-full-height-side',
    twoside: {
      defaultArtworkAspectRatio: 1.4
    },
    panel: {
      isHeaderDark: true,
      isSidebarDark: false
    }
  },
  chartTheme: {
    colors: [
      '#d4daf4', '#0fc86e', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4'],
    chart: {
      backgroundColor: {
      },
    },
    title: {
      style: {
        color: '#000',
      }
    },
    subtitle: {
      style: {
        color: '#666666',
      }
    },
    legend: {
      itemStyle: {
        color: 'black'
      },
      itemHoverStyle:{
        color: 'gray'
      }   
    }
  }
}
